var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3964 3.98525C11.0151 4.48279 11.5533 5.06906 12 5.71963C12.4467 5.06899 12.985 4.48267 13.6038 3.98509C13.2385 3.26371 12.704 2.58793 12.0001 2C11.2963 2.58798 10.7617 3.26381 10.3964 3.98525Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3414 12C13.1651 9.66962 15.3876 8 18 8C18 9.53671 17.4223 10.9385 16.4722 12H18C18.5523 12 19 12.4477 19 13V14C19 14.5523 18.5523 15 18 15H17L16.0988 21.1104C16.0426 21.6169 15.6145 22 15.105 22H8.89504C8.38549 22 7.95743 21.6169 7.90116 21.1104L7 15H6C5.44772 15 5 14.5523 5 14V13C5 12.4477 5.44772 12 6 12H7.52779C6.57771 10.9385 6 9.53671 6 8C8.61244 8 10.8349 9.66962 11.6586 12H12.3414Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9543 6.57232C17.0496 5.73487 16.9981 4.86457 16.7788 4C14.2909 4.70424 12.5349 6.85388 12.1036 9.36454C13.2732 7.87888 14.9922 6.84603 16.9543 6.57232Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22119 4C9.70913 4.70424 11.4651 6.85388 11.8964 9.36454C10.7268 7.87888 9.0078 6.84603 7.04569 6.57232C6.95043 5.73487 7.0019 4.86457 7.22119 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantAlt);
export default __webpack_public_path__ + "static/media/plant-alt.09228cf1721c2811fa9316423e81d93e.svg";
export { ForwardRef as ReactComponent };